<template>
  <div>
    <v-snackbar class="snakbar-sty rounded-pill" transition="slide-x-reverse-transition" v-model="snackbar" :timeout="3000" :value="true" :color="snackbarclr" absolute outlined>
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
    </v-snackbar>
    <div class="body-row pb-3 px-4 px-md-6 px-lg-8 pt-lg-6">
      <zebu-logo />
      <v-card class="elevation-0">
        <p class="mynt-eyebrow font-weight-bold mb-2">Welcome to Zebu</p>
        <p class="mynt-title font-weight-bold mb-7">Change or Reset Password</p>

        <div>
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate()">
            <v-text-field :disabled="userIdvalid" v-model="userId" :rules="useridRules" color="#0037B7" class="mynt-field mb-3" label="Client ID" required oninput="this.value = this.value.toUpperCase()"></v-text-field>

            <v-text-field
              :disabled="valdatadis"
              v-model="oldpassword"
              required
              :append-icon="oldpwseye ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="oldpwsRules"
              :type="oldpwseye ? 'text' : 'password'"
              color="#0037B7"
              class="mynt-field mb-3"
              label="Old Password or Received Password"
              hint="Enter the old Password for Change Password or received Password through email/SMS for Forgot Password."
              @click:append="oldpwseye = !oldpwseye"
            ></v-text-field>

            <v-text-field
              :disabled="valdatadis"
              v-model="newpassword"
              required
              :append-icon="newpwseye ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="newpwsRules"
              :type="newpwseye ? 'text' : 'password'"
              color="#0037B7"
              class="mynt-field mb-3"
              label="New Password"
              hint="New Password couldn't be changed as it is among the previous 3 passwords."
              @click:append="newpwseye = !newpwseye"
            ></v-text-field>

            <div class="mt-4" :style="`cursor: ${valid != true ? 'not-allowed' : 'auto'};`">
              <v-btn height="47px" :disabled="!valid" type="submit" color="#0037B7" class="text-none mynt-btn elevation-0 mb-1" block> <span class="white--text mynt-btn-label">Reset Password</span></v-btn>
            </div>

            <p class="mb-0 mt-3">
              <v-row no-gutters>
                <v-col cols="5" class="text-left pr-3">
                  <v-btn text :ripple="false" color="#0037B7" class="px-0 mb-2 elevation-0" small @click="backtoMyntin()">
                    <span class="mynt-link text-none"> Back to login </span>
                  </v-btn>
                </v-col>
                <v-col cols="7" class="text-right">
                  <v-list-item-title>
                    <v-btn text :ripple="false" color="#0037B7" class="px-0 mb-2 elevation-0" small @click="forgotPws()">
                      <span class="mynt-link text-none"> Forgot password</span>
                    </v-btn></v-list-item-title
                  >
                </v-col>
              </v-row>
            </p>
          </v-form>
          <p class="mynt-signup mb-0 text-center mt-6">Don't have an account yet? <a class="mynt-link" style="text-decoration: none" href="https://oa.mynt.in?ref=desk">Sign Up</a></p>
        </div>
      </v-card>
      <v-footer padless absolute color="#fff">
        <v-col class="text-center font-weight-medium fs-13 px-lg-8 px-md-6 px-lg-8 pb-2 mynt-legal" cols="12"
          ><span class="font-weight-bold fs-14 black--text"> Zebu Share and Wealth Managements Pvt. Ltd. </span><br />
          SEBI Registration No: INZ000174634 | NSE : 13179 | BSE : 6550 | MCX : 55730 | CDSL : 12080400 | AMFI ARN : 113118 | Research Analyst : INH200006044
        </v-col>
      </v-footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mynturl} from "../../apiUrl.js";
import {sha256} from "js-sha256";
import ZebuLogo from "../../components/ZebuLogo.vue";

export default {
  components: {ZebuLogo},

  data: () => ({
    snackbar: false,
    snackbarclr: "default",
    snackmsgbar: "",
    valdatadis: false,
    userIdvalid: true,
    valid: true,
    fgotpwdcliid: "",
    userId: "",
    useridRules: [(v) => !!v || "Client Id is required"],
    newpwseye: false,
    newpassword: "",
    newpwsRules: [(v) => !!v || "New Password is required", (v) => v.length >= 8 || "New Password of minimum 8 characters", (v) => /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(v) || "New Password must contain at least lowercase letter, one number, a special character and one uppercase letter"],
    oldpwseye: false,
    oldpassword: "",
    oldpwsRules: [(v) => !!v || "Old Password is required"],
  }),

  async created() {},
  mounted() {
    this.fgotpwdcliid = localStorage.getItem("FgotPwduserid");
    let chgpwsid = localStorage.getItem("tvchg.pws.id");

    // console.log("this.fgotpwdcliid", this.fgotpwdcliid);
    if (this.fgotpwdcliid != null) {
      this.userId = this.fgotpwdcliid;
      this.userIdvalid = true;
    } else if (chgpwsid != null) {
      this.userId = chgpwsid;
      this.userIdvalid = true;
    } else {
      this.userId = "";
      this.userIdvalid = false;
    }
    // var axios = require('axios');
  },

  methods: {
    validate() {
      var oldshapass = sha256(this.oldpassword);
      this.$refs.form.validate();
      if (this.$refs.form.validate() != false) {
        var axiosThis = this;
        var data = `jData={"uid":"${this.userId}","oldpwd":"${oldshapass}","pwd":"${this.newpassword}"}`;
        var config = {
          method: "post",
          url: `${mynturl}/Changepwd`,
          headers: {
            "Content-Type": "text/plain",
            Cookie: "NWC_ID=3e03100f85c0155ffb62d5d9bcc0ee273e804c489e430ddb9e00eda1aab50f54",
          },
          data: data,
        };
        axios(config)
          .then(function (response) {
            if (response.data.dmsg && (response.data.dmsg.includes("Password Change Success") || response.data.dmsg.includes("Change Success"))) {
              axiosThis.valdatadis = true;
              axiosThis.snackbarclr = "#22ab94";
              setTimeout(function () {
                axiosThis.$router.push("/sso");
                localStorage.removeItem("FgotPwduserid");
                localStorage.removeItem("tvchg.pws.id");
              }, 2400);
            } else if (response.data.emsg == "Error Occurred : Invalid Old Password") {
              axiosThis.snackbarclr = "#f23645";
              axiosThis.oldpassword = "";
            } else {
              axiosThis.snackbarclr = "#f23645";
            }
            axiosThis.snackbar = true;
            axiosThis.snackmsgbar = response.data.dmsg ? response.data.dmsg : response.data.emsg ? response.data.emsg : response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    backtoMyntin() {
      this.$router.push("/sso");
    },
    forgotPws() {
      this.$router.push("/forgot_password");
    },
  },

  computed: {
    Otpbtn() {
      return this.otpvalid.length === this.otplength;
    },
  },
};
</script>
